import React from 'react';
// import FroalaEditor from 'react-froala-wysiwyg';
import FroalaEditor from 'froala-editor';
import { EventEmitter } from '@nile/components';

// Define popup template.
Object.assign(FroalaEditor.POPUP_TEMPLATES, {
  'customPlugin.popup': '[_BUTTONS_][_CUSTOM_LAYER_]'
});

// Define popup buttons.
Object.assign(FroalaEditor.DEFAULTS, {
  popupButtons: ['popupClose', '|', 'popupButton1', 'popupButton2']
});

// The custom popup is defined inside a plugin (new or existing).
FroalaEditor.PLUGINS.customPlugin = function(editor) {
  // Create custom popup.
  function initPopup() {
    // Load popup template.
    // var template = FroalaEditor.POPUP_TEMPLATES.customPopup;
    // if (typeof template == 'function') template = template.apply(editor);
    // // Popup buttons.
    // var popup_buttons = '';
    // // Create the list of buttons.
    // if (editor.opts.popupButtons.length > 1) {
    //   popup_buttons += '<div class="fr-buttons">';
    //   popup_buttons += editor.button.buildList(editor.opts.popupButtons);
    //   popup_buttons += '</div>';
    // }
    // // Load popup template.
    // var template = {
    //   buttons: popup_buttons,
    //   custom_layer: '<div class="custom-layer">Hello World!</div>'
    // };
    // // Create popup.
    // var $popup = editor.popups.create('customPlugin.popup', template);
    // return $popup;
  }

  // Show the popup
  function showPopup() {
    // Get the popup object defined above.
    // var $popup = editor.popups.get('customPlugin.popup');
    // // If popup doesn't exist then create it.
    // // To improve performance it is best to create the popup when it is first needed
    // // and not when the editor is initialized.
    // if (!$popup) $popup = initPopup();
    // // Set the editor toolbar as the popup's container.
    // editor.popups.setContainer('customPlugin.popup', editor.$tb);
    // // If the editor is not displayed when a toolbar button is pressed, then set BODY as the popup's container.
    // // editor.popups.setContainer('customPlugin.popup', $('body'));
    // // Trigger refresh for the popup.
    // // editor.popups.refresh('customPlugin.popup');
    // // This custom popup is opened by pressing a button from the editor's toolbar.
    // // Get the button's object in order to place the popup relative to it.
    // var $btn = editor.$tb.find('.fr-command[data-cmd="myButton"]');
    // // Compute the popup's position.
    // var left = $btn.offset().left + $btn.outerWidth() / 2;
    // var top =
    //   $btn.offset().top +
    //   (editor.opts.toolbarBottom ? 10 : $btn.outerHeight() - 10);
    // // Show the custom popup.
    // // The button's outerHeight is required in case the popup needs to be displayed above it.
    // editor.popups.show('customPlugin.popup', left, top, $btn.outerHeight());
  }

  // Hide the custom popup.
  function hidePopup() {
    editor.popups.hide('customPlugin.popup');
  }

  // Methods visible outside the plugin.
  return {
    showPopup: showPopup,
    hidePopup: hidePopup
  };
};

// Define an icon and command for the button that opens the custom popup.
FroalaEditor.DefineIcon('buttonIcon', { NAME: 'star' });
FroalaEditor.RegisterCommand('myButton', {
  title: 'Show Popup',
  icon: 'buttonIcon',
  undo: false,
  focus: false,
  popup: true,
  // Buttons which are included in the editor toolbar should have the plugin property set.
  plugin: 'customPlugin',
  callback: function() {
    if (!this.popups.isVisible('customPlugin.popup')) {
      this.customPlugin.showPopup();
    } else {
      if (this.$el.find('.fr-marker')) {
        this.events.disableBlur();
        this.selection.restore();
      }
      this.popups.hide('customPlugin.popup');
    }
  }
});

// ('insertFile');
// ('fileManager');
// ('fileInsert');

FroalaEditor.DefineIcon('attach', {
  NAME: 'advancedImageEditor',
  SVG_KEY: 'insertFile'
  // PATH:
  //   'M9.25208 5.58319L5.59474 9.24052C5.04408 9.79119 5.04408 10.6845 5.59474 11.2352V11.2352C6.14541 11.7859 7.03874 11.7859 7.58941 11.2352L12.4107 6.41386C13.4207 5.40386 13.4207 3.76652 12.4107 2.75652V2.75652C11.4007 1.74652 9.76341 1.74652 8.75341 2.75652L3.93208 7.57786C2.46274 9.04719 2.46274 11.4285 3.93208 12.8979V12.8979C5.40141 14.3672 7.78274 14.3672 9.25208 12.8979L12.1781 9.97186'
});
FroalaEditor.RegisterCommand('attachFile', {
  title: 'Attach files',
  icon: 'attach',
  focus: false,
  undo: false,
  refreshAfterCallback: false,
  callback: function() {
    console.log(this);
    EventEmitter.dispatch('openCustomAttachments');
  }
});

// Define custom popup close button icon and command.
FroalaEditor.DefineIcon('popupClose', { NAME: 'times' });
FroalaEditor.RegisterCommand('popupClose', {
  title: 'Close',
  undo: false,
  focus: false,
  callback: function() {
    this.customPlugin.hidePopup();
  }
});

// Define custom popup 1.
FroalaEditor.DefineIcon('popupButton1', { NAME: 'bell-o' });
FroalaEditor.RegisterCommand('popupButton1', {
  title: 'Button 1',
  undo: false,
  focus: false,
  callback: function() {
    alert('popupButton1 was pressed');
  }
});

// Define custom popup 2.
FroalaEditor.DefineIcon('popupButton2', { NAME: 'bullhorn' });
FroalaEditor.RegisterCommand('popupButton2', {
  title: 'Button 2',
  undo: false,
  focus: false,
  callback: function() {
    alert('popupButton2');
  }
});

// Define custom popup 2.

const customSVGIcon = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.25 2.5H4.16667C3.24583 2.5 2.5 3.24583 2.5 4.16667V6.25" style="fill: none;" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2.5 13.75V15.8333C2.5 16.7542 3.24583 17.5 4.16667 17.5H6.25" style="fill: none;" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.75 17.5H15.8333C16.7542 17.5 17.5 16.7542 17.5 15.8333V13.75" style="fill: none;" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M17.5 6.25V4.16667C17.5 3.24583 16.7542 2.5 15.8333 2.5H13.75" style="fill: none;" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M11.1133 9.43177C11.7111 10.0296 11.7111 10.9989 11.1133 11.5967C10.5155 12.1945 9.5462 12.1945 8.94837 11.5967C8.35054 10.9989 8.35054 10.0296 8.94837 9.43177C9.5462 8.83394 10.5155 8.83394 11.1133 9.43177" style="fill: none;" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M14.6875 8.43751V13.125C14.6875 13.7 14.2208 14.1667 13.6458 14.1667H6.35417C5.77917 14.1667 5.3125 13.7 5.3125 13.125V8.43751C5.3125 7.86251 5.77917 7.39584 6.35417 7.39584H7.39583L8.1575 6.09168C8.25083 5.93168 8.42167 5.83334 8.6075 5.83334H11.37C11.5525 5.83334 11.7217 5.92918 11.8167 6.08584L12.605 7.39584H13.6467C14.2208 7.39584 14.6875 7.86251 14.6875 8.43751V8.43751Z" style="fill: none;" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

FroalaEditor.RegisterCommand('takeSnapshot', {
  title: 'Screenshot',
  focus: false,
  undo: true,
  icon: customSVGIcon,
  refreshAfterCallback: true,
  callback: function() {
    this.commands.exec('screenshot');
  }
});

// console.log('pvs:: editor:: ', FroalaEditor);
// console.log('pvs:: editor:: ', FroalaEditor.events);
// console.log('pvs:: editor:: ', FroalaEditor.POPUP_TEMPLATES);
// console.log('pvs:: editor:: ', FroalaEditor.DEFAULTS);
// console.log('pvs:: editor:: ', FroalaEditor.ICONS);
// console.log('pvs:: editor:: ', FroalaEditor.SVG);
// console.log('pvs:: editor:: ', FroalaEditor.ICON_TEMPLATES);

export default FroalaEditor;
